import axiosInstance from '@fs/zion-axios'
import getProductHeader from '../common/getProductHeader'

let isActive = false

export function setSourceCentricDetailsActive(active: boolean): void {
  isActive = active
}

axiosInstance.interceptors.request.use((config) => {
  if (!isActive) return config

  config.headers.product = getProductHeader({ featureOverride: 'source-centric' })

  return config
})
